/**
 * Daily Checks Library
 *
 * FT-80 Phase 4: Simplified to ONE default category.
 * Users can add more categories in Settings.
 * Based on industry best practice and WBC3 SMS requirements.
 */

export const DAILY_CHECK_CATEGORIES = {
  GENERAL: 'general'
};

export const DAILY_CHECK_CATEGORY_LABELS = {
  [DAILY_CHECK_CATEGORIES.GENERAL]: 'Daily Checks'
};

export const DAILY_CHECK_CATEGORY_ICONS = {
  [DAILY_CHECK_CATEGORIES.GENERAL]: 'ClipboardCheck'
};

/**
 * Default daily checks - ONE category with essential items
 * Users can customise in Settings and add more categories
 */
export const DEFAULT_DAILY_CHECKS = {
  [DAILY_CHECK_CATEGORIES.GENERAL]: [
    // Engine/Mechanical checks
    { id: 'oil_levels', text: 'Oil levels checked (engine, gearbox, hydraulic)', required: true },
    { id: 'coolant_level', text: 'Coolant level checked', required: true },
    { id: 'fuel_levels', text: 'Fuel levels recorded', required: true },
    { id: 'bilge_check', text: 'Bilges checked for water/oil', required: true },
    { id: 'exhaust_flow', text: 'Exhaust water flow confirmed', required: true },

    // Navigation/Bridge checks
    { id: 'nav_lights', text: 'Navigation lights tested', required: true },
    { id: 'vhf_check', text: 'VHF radio check completed', required: true },
    { id: 'gps_check', text: 'GPS position confirmed', required: true },
    { id: 'horn_test', text: 'Horn/whistle tested', required: true },

    // Safety checks
    { id: 'fire_extinguishers', text: 'Fire extinguishers in place and sealed', required: true },
    { id: 'lifejackets_check', text: 'Lifejackets accessible and serviceable', required: true },
    { id: 'lifebuoys_check', text: 'Lifebuoys in place with lights attached', required: true },

    // Deck checks
    { id: 'deck_clear', text: 'Deck clear of hazards and debris', required: true },
    { id: 'mooring_lines', text: 'Mooring lines in good condition', required: true }
  ]
};

/**
 * Get icon component name for category
 */
export const getDailyCheckIcon = (category) => {
  return DAILY_CHECK_CATEGORY_ICONS[category] || 'ClipboardCheck';
};
